import { render, staticRenderFns } from "./orderdetail.vue?vue&type=template&id=180bbd98&"
import script from "./orderdetail.vue?vue&type=script&lang=js&"
export * from "./orderdetail.vue?vue&type=script&lang=js&"
import style0 from "./orderdetail.vue?vue&type=style&index=0&id=180bbd98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports